import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  SFMergeFeature, 
} from "@dndModels";

import SelectSpecialFeatureTypeBox from "@dndComponents/select/SelectSpecialFeatureTypeBox";

type Props = {
  sff: SFMergeFeature;
  onChange: (sff: SFMergeFeature) => void; 
  disabled: boolean;
}

export interface State { 
  obj: SFMergeFeature;
  loading: boolean;
}

class SFMergeFeatureInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      obj: new SFMergeFeature(),
      loading: true
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <Grid container spacing={0} direction="column">
        <Grid>
          <SelectSpecialFeatureTypeBox 
            name="Merging Types"
            values={this.props.sff.special_feature_types} 
            multiple
            disabled={this.props.disabled}
            onChange={(types: string[]) => {
              const obj = this.props.sff;
              obj.special_feature_types = types;
              this.props.onChange(obj);
              this.setState({ obj });
            }} 
          />
        </Grid>
      </Grid>
    );
  }
}

export default SFMergeFeatureInput;
